import React from 'react'

export default function WeddingExperience() {
  return (
    <>
      <section className="wedding-experience-area">
        <img src="/image/wedding-experience.webp" alt="experience" className="img-responsive"/>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-5">
              <div className="wedding-experience-content wow animate__animated animate__fadeInUp" data-wow-delay="0.2s" data-wow-duration="1.2s">
                <h2 className='heading'>Signature Wedding Experiences</h2>
                <span>At De Coracao Resort, our Signature Wedding Experiences are designed around you. We move beyond one-size-fits-all packages to create destination celebrations that reflect your personality, blending forest-inspired décor, locally influenced gourmet menus, and seamless coordination. From enchanting venues to personalized details, we create a relaxed, authentic, and unforgettable destination wedding experience for every guest.</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
